export default __webpack_public_path__ + "static/media/O_Onibus.23d0772e.mp3";